import { GlobalIdleContext, useTabActive } from "@/components/context-providers/GlobalIdleWrapper";
import { useContext, useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";

const DEFAULT_TIMEOUT = 60 * 1000;

export function useIdleOriginal(timeout: number = DEFAULT_TIMEOUT) {
  const tabIsActive = useTabActive();
  const [idle, setIdle] = useState(false);
  useIdleTimer({
    timeout,
    onIdle: () => setIdle(true),
    onActive: () => setIdle(false),
  });

  return idle || !tabIsActive;
}

export interface UseIdleOpts {
  onExitIdle?: () => void;
  onEnterIdle?: () => void;
}

export function useIdle({ onExitIdle, onEnterIdle }: UseIdleOpts = {}): boolean {
  const isIdle = useContext(GlobalIdleContext);

  useEffect(() => {
    if (!isIdle) {
      onExitIdle?.();
    } else {
      onEnterIdle?.();
    }
  }, [isIdle, onEnterIdle, onExitIdle]);

  return isIdle;
}
